import React, { useState } from 'react';
import Cookies from 'js-cookie';

import { useAuth } from '../../../authentication/AuthenticationContext';
import { useConfig } from '../../../ConfigContext';
import { del, post } from '../../../utils/Request';
import logoStadia from '../../../_assets/stadia.svg';
import { GoogleSdkLoader } from '../../../_shared/GoogleSdkLoader';
import { ProviderLink } from '../provider/ProviderLink';
import { RequestError } from '../../../Error.model';
import { ProviderNames } from '../ProviderEnum';

export function Stadia(): JSX.Element {
  const config = useConfig();
  const auth = useAuth();
  const [error, setError] = useState<RequestError | null>(null);
  const requiredScopes = ['https://www.googleapis.com/auth/stadia.profile'];

  if (!Cookies.get('isSdkLoaded')) {
    Cookies.set('isSdkLoaded', 'false');
  }

  const link = (): void => {
    if (!Cookies.get('isSdkLoaded')) {
      return;
    }

    const authInstance = window.gapi.auth2.getAuthInstance();
    if (authInstance) {
      authInstance.signIn({
        scope: requiredScopes.join(' '),
        ux_mode: 'popup',
      }).then((user) => {
        post(`${config.clientConfig.host}/players/me/link`, {
          data: {
            type: ProviderNames.STADIA,
            data: {
              token: user.getAuthResponse().access_token,
            },
          },
        })
          .then(() => {
            setError(null);
            auth.getPlayer();
          })
          .catch((err: RequestError) => {
            setError(err);
          });
      }).catch((err: { error: string }) => {
        if (err.error !== 'popup_closed_by_user') {
          console.error(err);
        }
      });
    }
  };

  const onSdkLoaded = (): void => {
    Cookies.set('isSdkLoaded', 'true');
  };

  const unlink = (): void => {
    setError(null);
    del(`${config.clientConfig.host}/players/me/unlink/providers/stadia`)
      .then(() => {
        auth.getPlayer();
      }).catch((err: RequestError) => {
        setError(err);
      });
  };

  return (
    <>
      <ProviderLink
        providerName={ProviderNames.STADIA}
        logo={logoStadia}
        link={link}
        unlink={unlink}
        error={error}
      />
      <GoogleSdkLoader onLoad={onSdkLoaded} clientId={config.serverConfig.providers.stadia.clientId} />
    </>
  );
}
